import {
	Component,
	ElementRef,
	inject,
	input,
	OnInit,
	output,
	ViewEncapsulation,
} from '@angular/core';
import { ToolbarItem } from '../interfaces/toolbar-item.interface';
import { ToolBarItems } from '../consts/toolbar-items.const';
import Quill from 'quill';

@Component({
	selector: 'ui-rich-text-editor-toolbar',
	templateUrl: './rich-text-editor-toolbar.component.html',
	styleUrls: ['./rich-text-editor-toolbar.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class RichTextEditorToolbarComponent implements OnInit {
	public elementRef: ElementRef = inject(ElementRef);
	toolbarItems: ToolbarItem[] = ToolBarItems;

	id = input<string>('');

	undo = output<void>();
	redo = output<void>();

	ngOnInit() {
		this.setupIcons();
	}

	/**
	 * Overwrite the default icons with our custom ones
	 */
	setupIcons() {
		const icons = Quill.import('ui/icons') as any;
		this.toolbarItems.forEach((item: ToolbarItem) => {
			if (item.icon) {
				if (!icons[item.class]) {
					icons[item.class] = {}; // Initialize the object if it doesn't exist
				}
				if (item.value) {
					icons[item.class][item.value] = item.icon;
				} else {
					icons[item.class] = item.icon;
				}
			}
		});
	}

	onUndo() {
		this.undo.emit();
	}

	onRedo() {
		this.redo.emit();
	}
}
